import { useQuery, UseQueryResult } from 'react-query'
import CompanyDto from '../dto/companyDto'
import AddressDto from 'dto/addressDto'
import Company from '../models/company'
import { getDeveloperApiUrl } from '../utils/env'
import { FetchError } from '../utils/error'
import { GET_OPTIONS } from '../utils/fetch'
import { Address } from '@energytoolbase/components'
import { useAuth } from 'context/authContext'

function addressFromDto(addressDto: AddressDto): Address {
  const castToOptionalNumber = (
    value: string | undefined
  ): number | undefined => (value !== undefined ? Number(value) : undefined)

  const {
    addressSingleLine,
    city,
    country,
    latitude,
    longitude,
    postalCode,
    state,
    street1,
    street2,
    timeZone
  } = addressDto

  return {
    addressSingleLine,
    city,
    country,
    postalCode,
    state,
    street: street1,
    suite: street2,
    timeZone,
    latitude: castToOptionalNumber(latitude),
    longitude: castToOptionalNumber(longitude)
  }
}

function companyFromDto(serverCompany: CompanyDto): Company {
  return {
    ...serverCompany,
    mailingAddress: addressFromDto(serverCompany.mailingAddress)
  }
}

async function getCompany(): Promise<Company | undefined> {
  const url = `${getDeveloperApiUrl()}/global/companydata/getcompanyinfo`
  const response = await fetch(url, {
    ...GET_OPTIONS
  })

  if (!response.ok) {
    throw new FetchError(response)
  }

  const serverCompany = (await response.json()) as CompanyDto

  return companyFromDto(serverCompany)
}

export const companyQueryKey = 'company'

export default function useCompany(): UseQueryResult<Company> {
  const { token } = useAuth()
  return useQuery({
    queryFn: getCompany,
    queryKey: companyQueryKey,
    staleTime: Infinity,
    enabled: !!token // Only query if we are logged in
  })
}
